import { useCallback, useEffect } from "react";

import { useRouter } from "next/router";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

import { KHeaderWidget } from "../../../../models/configuration/components/kHeaderWidget";
import {
  kHeaderWidgetAllBurgerOpentState,
  kHeaderWidgetBurgerOpenState,
  kHeaderWidgetComponentsAtom,
} from "../atoms";
import { KHeaderWidgetComponent, KHeaderWidgetComponentContext } from "../models";

export type UseKHeaderWidgetBurger = {
  isOpen: boolean;
  handleClose: () => void;
  handleOpen: () => void;
  components: KHeaderWidgetComponent[];
};

type UseKHeaderWidgetBurgerProps = {
  widgetId: KHeaderWidget["id"];
};

export const useKHeaderWidgetBurger = ({
  widgetId,
}: UseKHeaderWidgetBurgerProps): UseKHeaderWidgetBurger => {
  const setAllBurgerState = useSetRecoilState(kHeaderWidgetAllBurgerOpentState);
  // Burger Menu
  const [isOpen, setIsOpen] = useRecoilState(kHeaderWidgetBurgerOpenState(widgetId));
  const handleClose = useCallback(() => {
    setIsOpen(false);
    setAllBurgerState(false);
  }, [setIsOpen, setAllBurgerState]);

  const handleOpen = () => {
    setIsOpen(true);
    setAllBurgerState(true);
  };

  // Components
  const burgerComponents = useRecoilValue(
    kHeaderWidgetComponentsAtom({ widgetId, context: KHeaderWidgetComponentContext.Burger }),
  );

  // Close on router change
  const router = useRouter();
  useEffect(() => {
    handleClose();
  }, [handleClose, router.pathname, router.query]);

  return {
    isOpen,
    handleClose,
    handleOpen,
    components: burgerComponents,
  };
};
